export function _toPlainDate(value) {
    if (value === null || typeof value === 'undefined' || value === false) {
        return null;
    }

    if (value instanceof Date) {
        return value;
    }

    if (value && typeof value.toJSDate === 'function') {
        return value.toJSDate();
    }

    if (value && typeof value.toDate === 'function') {
        return value.toDate();
    }

    if (typeof value === 'string' || typeof value === 'number') {
        var parsed = new Date(value);

        return isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
}

export function _toLegacyBootstrapDateFormat(format) {
    if (!format || typeof format !== 'string') {
        return undefined;
    }

    return format
        .replace(/YYYY/g, 'yyyy')
        .replace(/YY/g, 'yy')
        .replace(/DD/g, 'dd')
        .replace(/\bhh\b/g, 'HH')
        .replace(/\bA\b/g, 'T')
        .replace(/\ba\b/g, 't');
}

export function _normalizeColorValue(color) {
    if (!color || typeof color !== 'string') {
        return '';
    }

    if (color[0] === '#') {
        return color;
    }

    if (/^[0-9a-fA-F]{6}$/.test(color)) {
        return '#' + color;
    }

    return '';
}

export function getUrlVars() {
    var vars = {};
    window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key, value) {
            vars[key] = value;
        }
    );
    return vars;
}

export function formatCurrency(value) {
    return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function spinnerHtml(text) {
    var icon = '<i class="fa fa-circle-o-notch fa-spin"></i>';
    return text ? icon + ' ' + text : icon;
}

export function appendRel(youtubeURI) {
    if (typeof youtubeURI !== 'string' || youtubeURI.length === 0) {
        return youtubeURI;
    }

    if (youtubeURI.indexOf('?') !== -1) {
        return youtubeURI + '&rel=0';
    }

    return youtubeURI + '?rel=0';
}

/**
 * Resolve a "#elementId" string to a DOM node. IDs may contain "." and other
 * characters that break jQuery/CSS selectors (e.g. $("#id.with-dots")).
 */
export function getElementByHashId(hashId) {
    if (!hashId || typeof hashId !== 'string' || hashId.charAt(0) !== '#') {
        return null;
    }
    var id = hashId.slice(1);
    if (!id) {
        return null;
    }
    return document.getElementById(id);
}
